import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CollectionsModule} from '../collections/collections.module';
import {SearchFilterModule} from '../search-filter/search-filter.module';
import {HomeComponent} from './components';
import {HighlightsComponent} from './components/highlights/highlights.component';
import {AccountInformationComponent} from './components/account-information/account-information.component';
import {ContactComponent} from './components/contact/contact.component';
import {PrivacyPolicyComponent} from './components/privacy-policy/privacy-policy.component';
import {ImprintComponent} from './components/imprint/imprint.component';
import {PagesRoutingModule} from './pages-routing.module';
import {TermsOfServiceComponent} from './components/terms-of-service/terms-of-service.component';
import {I18NextModule} from 'angular-i18next';
import {CoreModule} from '../../core/core.module';
import {ChangePinComponent} from './components/change-pin/change-pin.component';
import {CodeInputModule} from 'angular-code-input';


@NgModule({
  declarations: [
    HomeComponent,
    HighlightsComponent,
    AccountInformationComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    ImprintComponent,
    TermsOfServiceComponent,
    ChangePinComponent],
  imports: [
    CommonModule,
    PagesRoutingModule,
    CollectionsModule,
    SearchFilterModule,
    I18NextModule,
    CoreModule,
    CodeInputModule
  ]
})
export class PagesModule {
}
